// Core Imports
import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Col, Row } from 'react-bootstrap';

// Icons
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const GetInTouch = () => {
  return (
    <section className="touch bg-2">
      {/* Background wrapper for styling */}
      <div className="bgc-2">
        <Container>
          <Row>
            {/* Text Section */}
            <Col md={9} className="my-auto">
              {/* <h2>For a Better Future and Business, Don’t Hesitate to Contact Us</h2> */}
              <h4>Whether you’re planning a new build, upgrading an existing property, or need help completing a challenging project, we’d love to talk.</h4>
            </Col>

            {/* CTA Button */}
            <Col md={3} className="text-center my-auto">
              <Link to="/contact-us" className="btn btn-secondary">
                Get In Touch <ArrowRightAltIcon />
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default GetInTouch;
